import React, { useEffect, useState } from "react";
import { Auth, Hub } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import { appCtx, isAWS } from "./AppContext";
import { awsAuth, awsAuthHosted } from "../aws-exports";
import '@aws-amplify/ui-react/styles.css';
import "./AwsUser.scss";
import { Divider } from "./CommonUIComponenets";
import gytpolScreenLight from '../img/gytpol_screen_light.png'
import gytpolScreenDark from '../img/gytpol_screen_dark.png'
import {ReactComponent as GytpolLogoWhite} from '../img/GYTPOL-logo-white.svg'
import {ReactComponent as GytpolLogoColor} from '../img/GYTPOL-logo-color.svg'
import { useColorModeTheme } from "../tools/CommonReact";
import {Button} from "../tools/Inputs";

Auth.configure(process.env.REACT_APP_AUTH_OIDC === "hosted" ? awsAuthHosted : awsAuth);
//Auth.configure({ storage: window.sessionStorage });           // user token will be saved in sessionStorage instead of localStorage

export function CheckAuth({ children }) {
    return !isAWS? children :
        process.env.REACT_APP_AUTH_OIDC === "hosted" ?
            <HostedAuth {...{ children }} /> :
            <CognitoAuth {...{ children }} />
}


async function getIdJwtToken() {
    const session = await Auth.currentSession();
    return session.idToken.jwtToken;
}


function HostedAuth({ children }) {
    const [isSignedIn, setIsSignedIn] = useState(false);
    const {curTheme} = useColorModeTheme();

    //const signIn = () => Auth.federatedSignIn({provider: "azuread"});       // remove provider to get to Cognito's Hosted UI.
    const signIn = () => Auth.federatedSignIn();       // remove provider to get to Cognito's Hosted UI.
    const signOut = () => (setIsSignedIn(false), Auth.signOut());

    useEffect(() => {
        Hub.listen('auth', ({ payload: { event, data } }) => {
            //console.log("Hub", event);
            if (event === "signIn_failure")
                console.log("Sign in failure", data);
        });

        // Check if authenticated. UI gets reloaded after redirected from hosted sign-in, so this gets executed again.
        Auth.currentAuthenticatedUser()      // {bypassCache: true}
            .then(user => {
                //console.log("Auth:", user, user.signInUserSession?.idToken?.payload?.email);
                // appCtx.nav.isInLogin = false;
                afterAuth({ user, signOut })
                setIsSignedIn(true);
            })
            .catch(() => 0);
    }, []);

    return isSignedIn ? children : appCtx.nav.isInLogin ? null :
        <div className="w-full h-full flex justify-center p-20 items-center">
            <img style={{userDrag: "none", "-webkit-user-drag": "none"}}
                 className="absolute w-full h-full blur select-none" src={curTheme !== "dark"? gytpolScreenLight : gytpolScreenDark}/>
            <div style={{backdropFilter: 'blur(8px'}} className="w-full h-full flex flex-col items-center justify-center gap-8 p-6 bg-gray-300/25 rounded-2xl shadow-md border-1">
                {React.createElement(curTheme !== "dark"? GytpolLogoColor : GytpolLogoWhite, {className: "h-1/6"})}
                <Divider className="w-full" classNameColor="bg-title"/>
                <div className="text-center text-4xl font-medium text-title">
                    Welcome to {process.env.REACT_APP_DESC}
                </div>
                <p className="italic text-2xl text-gray-300">Please sign in with your organizational credentials</p>
                <Button onClick={signIn} className="px-6 py-2 text-2xl text-prm-contrast bg-prm-main">Login</Button>
            </div>
        </div>
}

function CognitoAuth({children}) {
    const {curTheme} = useColorModeTheme();
    return (
        <Authenticator hideSignUp={true} components={{Header: () =>
                <div className="flex justify-center mb-2 py-2 bg-bg2">
                    {React.createElement(curTheme !== "dark"? GytpolLogoColor : GytpolLogoWhite, {className: "h-12"})}
                </div>}}>
            {aws => (afterAuth(aws), children)}
        </Authenticator>
    );
}

function afterAuth(aws) {
    appCtx.aws = aws;
    //console.log(aws.user)
    appCtx.aws.jwtToken = aws.user.signInUserSession?.idToken?.jwtToken;
    //ctx.aws.userId = aws.user.signInUserSession?.idToken?.payload?.email;
    appCtx.aws.getIdJwtToken = getIdJwtToken;
    if (appCtx.aws) setTimeout(() => {
        appCtx.user?.refetch();
        appCtx.license?.refetch();
        appCtx.domains?.refetch();
    }, 0);
    //console.log("Authenticator:", aws);
}
